__turbopack_context__.v({
  "handle": "ContextualPopup-module__PZGP6q__handle",
  "popupBackdrop": "ContextualPopup-module__PZGP6q__popupBackdrop",
  "popupBackground": "ContextualPopup-module__PZGP6q__popupBackground",
  "popupBackgroundOpen": "ContextualPopup-module__PZGP6q__popupBackgroundOpen",
  "popupBorder": "ContextualPopup-module__PZGP6q__popupBorder",
  "popupRoot": "ContextualPopup-module__PZGP6q__popupRoot",
});
